var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-item",attrs:{"href":_vm.nav.path}},[_c('img',{staticClass:"link-img",attrs:{"src":_vm.IMG_URL + _vm.nav.imgUrl}}),_vm._v(" "),_c('main',{staticClass:"link-title"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.nav.label))]),_vm._v(" "),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.nav.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb4a578","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Link.vue
// module id = null
// module chunks = 